import { Tooltip } from "@mui/material";
import { useEffect, useState } from "react";
import { FcInfo } from "react-icons/fc";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { Col, Row } from "reactstrap";
import { AssistanceNavBar } from "../../components/Assistances/AssistanceNavBar";
import DigitalSignature from "../../components/Assistances/DigitalSignature";
import ViewSignature from "../../components/Assistances/ViewSignature";
import ButtonComponent from "../../components/ButtonComponent";
import ChangeStatusComponent from "../../components/ChangeStatusComponent";
import useDynamicComponent from "../../components/dynamics/useDynamicComponent";
import FabricationComponent from "../../components/FabricationComponent";
import { generatePDF } from "../../components/GeneratePDF";
import Layout from "../../components/Layout/Layout";
import PageTitle from "../../components/Layout/PageTitle";
import { useMobile } from "../../components/Layout/UseResponsive";
import TechnicanCompontent from "../../components/TechnicanCompontent";
import { useAvailableModulesContext } from "../../context/AvailableModulesContext";
import Toast from "../../helpers/Toast";
import { AssistanceDTO } from "../../models/Assistance/AssistanceDTO";
import { DigitalSignatureDTO } from "../../models/Assistance/DigitalSignatureDTO";
import { EditTechnicianFromAssistanceDTO } from "../../models/Technician/EditTechnicianFromAssistanceDTO";
import { AssistanceService } from "../../services/AssistanceService";

function AssistanceEdit() {
    const { id } = useParams<{ id: string }>();
    const intl = useIntl();
    const isMobile = useMobile(606);
    const [isLoadingAssistance, setIsLoadingAssistance] = useState<boolean>(true);
    const [assistance, setAssistance] = useState<AssistanceDTO>({} as AssistanceDTO);
    const assistanceService = new AssistanceService();
    const [IsOpen, setIsOpen] = useState<boolean>(false);
    const [ChangeStatusIsOpen, setChangeStatusIsOpen] = useState<boolean>(false);
    const [FabricationIsOpen, setFabricationIsOpen] = useState<boolean>(false);
    const [reload, setReload] = useState<boolean>(false);
    const [stockEntryDocumentErpId, setStockEntryDocumentErpId] = useState<boolean>(true);
    const [isSignatureOpen, setIsSignatureOpen] = useState(false);
    const [isViewSignatureOpen, setIsViewSignatureOpen] = useState<boolean>(false);
    const { availableModules } = useAvailableModulesContext();
    // Module settings (derived from availableModules)
    const isActiveFabricationModule = availableModules.includes("FabricationSage50cIsActiveFabricationModule");
    const isActiveErpSupportModule = availableModules.includes("IsActiveErpSupportModule");
    const isActivateDigitalSignature = availableModules.includes("IsActiveDigitalSignature");
    // Execuções / Tempos
    const [fetchExecutionsData, setFetchExecutionsData] = useState<boolean>(false);
    const onFetchExecutionsData = () => {
        setFetchExecutionsData(!fetchExecutionsData);
    };
    const mainContent = useDynamicComponent("AssistanceEdit", {
        assistance,
        setAssistance,
        isLoadingAssistance,
    });

    const setTechnician = async (technician: string) => {
        var data: EditTechnicianFromAssistanceDTO = {
            IdAssistance: Number(id),
            TechnicianCode: technician,
        };
        setIsLoadingAssistance(true);
        var response = await assistanceService.InsertOrUpdateTechnician(data);
        if (response.success === false) {
            setIsLoadingAssistance(false);
            Toast.Show("error", response.message);
            return;
        }
        Toast.Show("success", response.message);
        setIsLoadingAssistance(false);
        setIsOpen(false);
        setReload(!reload);
    };

    const handleSignatureDialog = () => {
        setIsSignatureOpen(!isSignatureOpen);
    };

    const handleSignatureCancel = () => {
        setIsSignatureOpen(false);
    };

    const handleSignatureSave = async (signatureData: DigitalSignatureDTO) => {
        // Chama a API com a assinatura
        const response = await assistanceService.SubmitDigitalSignature(Number(id), signatureData);
        if (response === null || !response.success) {
            Toast.Show("error", response.message);
        }
        setReload(!reload);

        Toast.Show("success", intl.formatMessage({ id: "AssistanceEdit.SignSuccess" }));
    }

    const handleSignaturePopUp = () => {
        setIsViewSignatureOpen(!isViewSignatureOpen);
    };

    const handleCloseSignaturePopUp = () => {
        setIsViewSignatureOpen(false);
    };

    const handleClearSignature = async () => {
        const response = await assistanceService.ClearDigitalSignature(Number(id));
        if (response === null || !response.success) {
            Toast.Show("error", response.message || "Erro ao limpar a assinatura");
        } else {
            Toast.Show("success", intl.formatMessage({ id: "AssistanceEdit.SignatureCleared" }) || "Assinatura limpa com sucesso");
            setIsViewSignatureOpen(false);
            setReload(!reload);
        }
    };

    useEffect(() => {
        const getAssistance = async () => {
            setIsLoadingAssistance(true);

            var response = await assistanceService.GetById(Number(id));
            if (response.success === false || response.obj == null) {
                setIsLoadingAssistance(false);
                Toast.Show("error", response.message);
                return;
            }
            setAssistance(response.obj);
            setIsLoadingAssistance(false);
        };

        getAssistance();
    }, [reload]);

    //obter valor do campo stockEntryDocumentErpId
    useEffect(() => {
        const fetchAssistanceData = async () => {
            try {
                const stockEntryDocumentErpIdResponse = await assistanceService.GetStockEntryDocumentErpId(Number(id));

                if (stockEntryDocumentErpIdResponse.success === false) {
                    Toast.Show("error", stockEntryDocumentErpIdResponse.message);
                    return;
                }

                // Atualizar o estado com o valor de stockEntryDocumentErpId
                setStockEntryDocumentErpId(stockEntryDocumentErpIdResponse.obj);

            } catch (error) {
                Toast.Show("error", "Erro ao obter dados da assistência");
            }
        };

        fetchAssistanceData();
    }, [id, reload]);

    return (
        <Layout>
            <TechnicanCompontent
                OnClick={setTechnician}
                OnCancel={() => setIsOpen(false)}
                Technician={assistance.technician}
                IsOpen={IsOpen}
            />
            <ChangeStatusComponent
                close={() => setChangeStatusIsOpen(false)}
                AssistanceId={assistance.id}
                IsOpen={ChangeStatusIsOpen}
                onAdded={() => setReload(!reload)}
            />
            <FabricationComponent
                close={() => setFabricationIsOpen(false)}
                AssistanceId={assistance.id}
                IsOpen={FabricationIsOpen}
                onAdded={() => setReload(!reload)}
            />

            {!isMobile ? (
                <div className="pageContainer">
                    <Row className="pageHeader" style={{ display: "flex", alignItems: "center", justifyContent: "start" }}>
                        <Col xl={4} lg={4} md={12} sm={12} xs={12} style={{ display: "flex", margin: "0px" }}>
                            <PageTitle
                                title={
                                    isActiveErpSupportModule
                                        ? `Assistência ${assistance.supportNumber}`
                                        : `Assistência ${assistance.erpDocType ?? ""} ${assistance.erpSerie ?? ""} ${assistance.erpNumDoc ?? ""} ${assistance.assistanceType === "Reparação"
                                            ? "- Reparação"
                                            : assistance.assistanceType === "Fabricação"
                                                ? "- Fabricação"
                                                : ""
                                        }`
                                }
                                allowGoBack={true}
                            />
                        </Col>
                        <Col
                            xl={8}
                            lg={8}
                            md={12}
                            sm={12}
                            xs={12}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "end",
                            }}
                        >
                            {isActivateDigitalSignature && (
                                <>
                                    {assistance.digitalSignature === null ? (
                                        <>
                                            {assistance.userCanEdit && (
                                                <>
                                                    <ButtonComponent
                                                        style={{
                                                            marginRight: "1%",
                                                            minWidth: "70px",
                                                        }}
                                                        text={intl.formatMessage({ id: "AssistanceEdit.Signature" })}
                                                        onClick={() => handleSignatureDialog()}
                                                    />
                                                    {isSignatureOpen && (
                                                        <DigitalSignature
                                                            onCancel={handleSignatureCancel}
                                                            onSave={(dataUrl: string) => {
                                                                const signatureData: DigitalSignatureDTO = {
                                                                    signature: dataUrl,
                                                                };
                                                                handleSignatureSave(signatureData);
                                                            }}
                                                        />
                                                    )}
                                                </>
                                            )}
                                        </>
                                    ) : (
                                        <>
                                            <ButtonComponent
                                                style={{
                                                    marginRight: "1%",
                                                    minWidth: "70px",
                                                }}
                                                text={intl.formatMessage({ id: "AssistanceEdit.SeeSignature" })}
                                                onClick={() => handleSignaturePopUp()}
                                            />
                                            {isViewSignatureOpen && (
                                                <ViewSignature
                                                    signature={assistance.digitalSignature ?? ""}
                                                    onClose={handleCloseSignaturePopUp}
                                                    onClear={assistance.userCanEdit ? handleClearSignature : undefined}
                                                    isSaved={true}
                                                />
                                            )}
                                        </>
                                    )}
                                </>
                            )}


                            {
                                <ButtonComponent
                                    style={{
                                        marginRight: "2%", minWidth: "139px"
                                    }}
                                    text={intl.formatMessage({ id: "AssistanceEdit.Download" })}
                                    onClick={() => generatePDF(assistance.erpNumDoc, assistance.erpDocType, assistance.erpSerie)}
                                />
                            }

                            {!assistance.userCanEdit && isActiveFabricationModule
                                && assistance.assistanceType === 'Fabricação'
                                && (
                                    <ButtonComponent
                                        style={{
                                            marginRight: "0.5%",
                                        }}
                                        text={intl.formatMessage({ id: "AssistanceEdit.Fabrication" })}
                                        onClick={() => setFabricationIsOpen(true)}
                                        disabled={stockEntryDocumentErpId != null}
                                    />
                                )
                            }

                            {!assistance.userCanEdit && isActiveFabricationModule
                                && assistance.assistanceType === 'Fabricação' && stockEntryDocumentErpId != null
                                && (
                                    <Tooltip title={<div style={{ fontSize: "12px", fontWeight: "bold" }}> Já foi registada uma fabricação para esta assistência. </div>} disableFocusListener enterTouchDelay={0} enterNextDelay={100} enterDelay={100} placement={"top"} style={{ cursor: "pointer", marginRight: "2%" }}>
                                        <b>
                                            <FcInfo className='notesIcon' fontSize={20} />
                                        </b>
                                    </Tooltip>
                                )
                            }

                            <span style={{ fontWeight: "bold", fontSize: "14px", marginRight: "2%" }}>
                                Técnico: {assistance.technician === "" ? "Não atribuído" : assistance.technician}{" "}
                            </span>

                            {assistance.userCanChangeTechnician && (
                                <ButtonComponent
                                    onClick={() => setIsOpen(true)}
                                    text={intl.formatMessage({
                                        id: assistance.technician === "" ?
                                            "AssistanceEdit.AssignTechnician" : "AssistanceEdit.UpdateTechnician"
                                    })}
                                    disabled={!assistance.userCanEdit}
                                    style={{
                                        marginRight: "4%",
                                    }}
                                />
                            )}
                            <span style={{ fontWeight: "bold", fontSize: "14px", marginRight: "2%", }}>
                                Estado: <span style={{ textTransform: "uppercase" }}>{assistance?.status}</span>
                            </span>
                            {assistance.userCanChangeStatus && (
                                <ButtonComponent onClick={() => setChangeStatusIsOpen(true)} style={{ minWidth: "104px" }}
                                    text={intl.formatMessage({ id: "AssistanceEdit.UpdateStatus" })}
                                />
                            )}
                        </Col>
                    </Row>

                    <div className="pageBody">
                        <Row>
                            <Col xl={6}>{mainContent}</Col>

                            <Col xl={6}>
                                <AssistanceNavBar
                                    mode={"backoffice"}
                                    setAssistance={setAssistance}
                                    assistance={assistance}
                                    isLoadingAssistance={isLoadingAssistance}
                                    getAssistance={function (): Promise<void> {
                                        throw new Error("Function not implemented.");
                                    }}
                                    reloadExecutions={false}
                                    onFetchExecutionsData={onFetchExecutionsData}
                                />
                            </Col>
                        </Row>
                    </div>
                </div>

            ) : (

                <div className="pageContainer">
                    <Row className="pageHeader">
                        <Row>
                            <Col xl={4} lg={4} md={12} sm={12} xs={12}>
                                <PageTitle
                                    title={
                                        isActiveErpSupportModule
                                            ? `Assistência ${assistance.supportNumber}`
                                            : `Assistência ${assistance.erpDocType ?? ""} ${assistance.erpSerie ?? ""} ${assistance.erpNumDoc ?? ""} ${assistance.assistanceType === "Reparação"
                                                ? "- Reparação"
                                                : assistance.assistanceType === "Fabricação"
                                                    ? "- Fabricação"
                                                    : ""
                                            }`
                                    }
                                    allowGoBack={true}
                                />
                            </Col>
                        </Row>

                        <Row style={{ marginBottom: "10px", marginTop: "10px" }}>
                            {isActivateDigitalSignature && (
                                <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                                    {assistance.digitalSignature === null ? (
                                        <>
                                            {assistance.userCanEdit && (
                                                <>
                                                    <ButtonComponent
                                                        style={{
                                                            marginRight: "1%",
                                                            minWidth: "70px",
                                                        }}

                                                        text={intl.formatMessage({ id: "AssistanceEdit.Signature" })}
                                                        onClick={() => handleSignatureDialog()}
                                                    />
                                                    {isSignatureOpen && (
                                                        <DigitalSignature
                                                            onCancel={handleSignatureCancel}
                                                            onSave={(dataUrl: string) => {
                                                                const signatureData: DigitalSignatureDTO = {
                                                                    signature: dataUrl,
                                                                };
                                                                handleSignatureSave(signatureData);
                                                            }}
                                                        />
                                                    )}
                                                </>
                                            )}
                                        </>
                                    ) : (
                                        <>
                                            <ButtonComponent
                                                style={{
                                                    marginRight: "1%",
                                                    minWidth: "70px",
                                                }}
                                                text={intl.formatMessage({ id: "AssistanceEdit.SeeSignature" })}
                                                onClick={() => handleSignaturePopUp()}
                                            />
                                            {isViewSignatureOpen && (
                                                <ViewSignature
                                                    signature={assistance.digitalSignature ?? ""}
                                                    onClose={handleCloseSignaturePopUp}
                                                    onClear={assistance.userCanEdit ? handleClearSignature : undefined}
                                                    isSaved={true}
                                                />
                                            )}
                                        </>
                                    )}
                                </Col>
                            )}
                        </Row>
                               
                        <Row style={{ marginBottom: "10px" }}>
                            <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                                <ButtonComponent
                                    style={{
                                        marginRight: "2%",
                                        minWidth: "139px",
                                    }}
                                    text={intl.formatMessage({ id: "AssistanceEdit.Download" })}
                                    onClick={() => generatePDF(assistance.erpNumDoc, assistance.erpDocType, assistance.erpSerie)}
                                />
                            </Col>
                        </Row>

                        <Row style={{ marginBottom: "10px" }}>
                            {!assistance.userCanEdit && isActiveFabricationModule && assistance.assistanceType === 'Fabricação' && (
                                <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                                    <ButtonComponent
                                        style={{
                                            marginRight: "0.5%",
                                        }}
                                        text={intl.formatMessage({ id: "AssistanceEdit.Fabrication" })}
                                        onClick={() => setFabricationIsOpen(true)}
                                        disabled={stockEntryDocumentErpId != null}
                                    />
                                </Col>
                            )}

                            {!assistance.userCanEdit && isActiveFabricationModule && assistance.assistanceType === 'Fabricação' && stockEntryDocumentErpId != null && (
                                <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                                    <Tooltip title={<div style={{ fontSize: "12px", fontWeight: "bold" }}>Já foi registada uma fabricação para esta assistência.</div>} disableFocusListener enterTouchDelay={0} enterNextDelay={100} enterDelay={100} placement={"top"} style={{ cursor: "pointer", marginRight: "2%" }}>
                                        <b>
                                            <FcInfo className='notesIcon' fontSize={20} />
                                        </b>
                                    </Tooltip>
                                </Col>
                            )}
                        </Row>

                        <Row style={{ marginBottom: "10px" }}>
                            <Col xl={6} lg={6} md={6} sm={6} xs={12}>
                                <span style={{ fontWeight: "bold", fontSize: "14px", marginRight: "2%" }}>
                                    Técnico: {assistance.technician === "" ? "Não atribuído" : assistance.technician}{" "}
                                </span>
                            </Col>

                            {assistance.userCanChangeTechnician && (
                                <Col xl={6} lg={6} md={6} sm={6} xs={12}>
                                    <ButtonComponent
                                        onClick={() => setIsOpen(true)}
                                        text={intl.formatMessage({
                                            id: assistance.technician === "" ? "AssistanceEdit.AssignTechnician" : "AssistanceEdit.UpdateTechnician",
                                        })}
                                        disabled={!assistance.userCanEdit}
                                        style={{
                                            marginRight: "4%",
                                        }}
                                    />
                                </Col>
                            )}
                        </Row>

                        <Row style={{ marginBottom: "10px" }}>
                            <Col xl={6} lg={6} md={6} sm={6} xs={12}>
                                <span style={{ fontWeight: "bold", fontSize: "14px", marginRight: "2%" }}>
                                    Estado: <span style={{ textTransform: "uppercase" }}>{assistance?.status}</span>
                                </span>
                            </Col>
                            {assistance.userCanChangeStatus && (
                                <Col xl={6} lg={6} md={6} sm={6} xs={12}>
                                    <ButtonComponent onClick={() => setChangeStatusIsOpen(true)} style={{ minWidth: "104px" }}
                                        text={intl.formatMessage({ id: "AssistanceEdit.UpdateStatus" })}
                                    />
                                </Col>
                            )}
                        </Row>
                    </Row>

                    <div className="pageBody">
                        <Row>
                            <Col xl={6}>{mainContent}</Col>

                            <Col xl={6}>
                                <AssistanceNavBar
                                    mode={"backoffice"}
                                    setAssistance={setAssistance}
                                    assistance={assistance}
                                    isLoadingAssistance={isLoadingAssistance}
                                    getAssistance={function (): Promise<void> {
                                        throw new Error("Function not implemented.");
                                    }}
                                    reloadExecutions={false}
                                    onFetchExecutionsData={onFetchExecutionsData}
                                />
                            </Col>
                        </Row>
                    </div>
                </div>
            )}
        </Layout>
    );
}

export default AssistanceEdit;
